<template>
  <div>
    <div class="wrap">
      <div class="module">
        <div class="module_item" v-for="(child, childIndex) in goodsList" :key="child.id"
          v-show="child.swiperList.length != 0">
          <div class="navBar"
            :style="child.colorType == '1' ? 'border-color:' + child.bgColorEnd + ';' : 'border-color:' + child.borderColor + ';'">
            <!-- <img class="itemTitle" :src="child.longImg" alt="">
            <div class="moreBtn"
              :style="child.colorType == '1' ? 'background:linear-gradient(to right,' + child.buttonColorStart + ',' + child.buttonColorEnd + ')' : ''"
              @click="jumpGoodsList(child)">
              <span class="more" :style="{ color: child.titleColor }">查看更多></span>
            </div> -->
            <img class="itemTitle" src="/images/index/starLeft.png" alt="">
            <div class="titleCon">
              <span>{{ child.title }}</span>
            </div>
            <img class="itemTitle" src="/images/index/starRight.png" alt="">
          </div>
          <div class="goodsBox" v-if="childIndex % 2 == 0">
            <div class="right">
              <swiper class="swiper" :options="child.swiperOption" ref="swiperTop">
                <swiper-slide class="swiper-slide" v-for="(swiper, index) in child.swiperList" :key="index">
                  <div class="cake">
                    <!-- <img :src="child.mainImg" alt="" class="module_img" v-if="index == 0"> -->
                    <div style="display: flex;justify-content: center;" v-for="(item, i) in swiper" :key="i">
                      <div class="item" @click.stop="jumpDetail(item)" :data-v='JSON.stringify(item)'>
                        <img :src="item.picUrl" :data-v='JSON.stringify(item)' alt="" class="img">

                        <div class="info">
                          <div class="name">{{ item.name }}</div>
                          <!-- <div class="free">包邮</div> -->
                          <div class="infoBottom">
                            <div class="price"><span>￥</span>{{ (Number(item.price) / 100).toFixed(2) }}</div>
                            <div class="num">已售{{ item.salesCount }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <div class="more" @click="jumpGoodsList(child)">查看更多></div>
          </div>
          <div class="goodsBox" v-else>
            <div class="right">
              <swiper class="swiper" :options="child.swiperOption" ref="swiperTop">
                <swiper-slide class="swiper-slide" v-for="(swiper, index) in child.swiperList" :key="index">
                  <div class="cake">
                    <!-- <img :src="child.mainImg" alt="" class="module_img2" v-if="index == 0"> -->
                    <div style="display: flex;justify-content: center;" v-for="item in swiper" :key="item.id">
                      <div class="item" @click.stop="jumpDetail(item)" :data-v='JSON.stringify(item)'>
                        <img :src="item.picUrl" :data-v='JSON.stringify(item)' alt="" class="img">
                        <div class="info">
                          <div class="name">{{ item.name }}</div>
                          <!-- <div class="free">包邮</div> -->
                          <div class="infoBottom">
                            <div class="price"><span>￥</span>{{ (Number(item.price) / 100).toFixed(2) }}</div>
                            <div class="num">已售{{ item.salesCount }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <div class="more" @click="jumpGoodsList(child)">查看更多></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'modulPage',
  data() {
    return {
      swiperOptionTop: {
        loop: false,
        loopedSlides: 5,
        spaceBetween: 14,
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        on: {
          click: (event) => {
            if (event.target.getAttribute('data-v')) {
              // 这里的 obj 就是当前点击图片所对应的信息
              let obj = JSON.parse(event.target.getAttribute('data-v'))
              this.jumpDetail(obj)
            }
          }
        }
      },
      swiperList: [],
      goodsList: [],
    };
  },
  created() {
    this.$store.dispatch('saveCategoryTitle', '')
    this.$store.dispatch('saveLayoutId', '')

  },
  mounted() {
    this.getLayoutList()
  },
  computed: {
    ...mapState(['cakeCityId', 'cakeCityName', 'floatStatus', 'backColors', 'fontsColor', 'txtColor', 'themeColor'])
  },
  watch: {
    // cakeCityId (newValue, oldValue) {
    //   console.log(newValue, oldValue);
    //   if (newValue != oldValue) {
    //     this.getCakeList()
    //   }
    // }
  },
  methods: {
    // 跳转更多
    jumpGoodsList(item) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$store.dispatch('saveLayoutId', item.id)
      this.$store.dispatch('saveCategoryTitle', item.title)
      this.$store.dispatch('saveCategoryId', '')
      this.$store.dispatch('saveWebGoodsInfo', '')
      this.$router.push({
        name: "layoutGoodsList",
      });
    },
    // 跳转商品详情
    jumpDetail(item) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      if (item.productType == 1) {
        this.$store.dispatch('saveGoodsId', item.id)
        this.$store.dispatch('saveCategoryTitle', '')
        this.$store.dispatch('saveModeType', 1)
        this.$router.push({
          name: "jdDetail",
        });
      } else {
        this.$store.dispatch('saveGoodsId', item.id)
        this.$store.dispatch('saveModeType', 1)
        this.$store.dispatch('saveCategoryTitle', '')
        this.$router.push({
          name: "detail",
        });
      }
    },
    getLayoutList() {
      this.$api.mall.getLayoutList().then((res) => {
        console.log(res, '布局');
        if (res.code == 200) {
          let data = !res.data ? [] : res.data
          this.goodsList = data
          if (data.length) {
            data.forEach((item, index) => {
              this.getGoodsList(item.id, index)
              item.swiperList = []
              item.swiperOption = {
                loop: false,
                loopedSlides: 5,
                on: {
                  click: (event) => {
                    if (event.target.getAttribute('data-v')) {
                      // 这里的 obj 就是当前点击图片所对应的信息
                      let obj = JSON.parse(event.target.getAttribute('data-v'))
                      this.jumpDetail(obj)
                    }
                  }
                }
              }
              // for (let i = 0; i < 3; i++) {
              //   let arr = []
              //   for (let j = 14 * i; j < (i + 1) * 14; j++) {
              //     arr.push(item.productSpuList[j])
              //   }
              //   item.swiperList.push(arr)
              // }
              // if (item.productSpuList.length <= 10) {
              //   item.swiperOption.loop = false
              // } else {
              //   item.swiperOption.loop = true
              // }
            });
          }
          console.log(data, 204);
        }
        this.$forceUpdate()
      });
    },
    getGoodsList(id, index) {
      this.$api.mall.getSpuList({
        layoutId: id,
        count: 40
      }).then((res) => {
        console.log(res, '商品列表');
        if (res.code == 200) {
          let data = !res.data ? [] : res.data
          if (data.length != 0) {
            let swiper = []
            for (let i = 0; i < 4; i++) {
              let arr = []
              for (let j = 5 * i; j < (i + 1) * 5; j++) {
                arr.push(data[j])
              }
              swiper.push(arr)
            }
            this.goodsList[index].swiperList = swiper
            if (data.length <= 4) {
              this.goodsList[index].swiperOption.loop = false
            } else {
              this.goodsList[index].swiperOption.loop = true
            }
          }
          console.log(res.data, 252222);
          console.log(this.goodsList, 252);

        }
        this.$forceUpdate()

      })
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  width: 100%;

  .module {
    width: 100%;

    .module_item {
      width: 100%;
      box-sizing: border-box;
      border-radius: 10px;
      box-sizing: border-box;
      margin-top: 24px;
    }

    .navBar {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      position: relative;
      margin-top: 48px;

      .itemTitle {
        width: 50px;
        height: 50px;
      }

      .titleCon {
        font-weight: bold;
        font-size: 39px;
        color: #333333;
        margin: 0 42px;
        position: relative;

        &::after {
          content: '';
          width: calc(100% - 20px);
          height: 42px;
          background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 40%, rgba(247, 226, 93, 0.65) 100%);
          border-radius: 18px;
          position: absolute;
          bottom: -5px;
          left: 10px;
          z-index: 1;
        }

        >span {
          position: relative;
          z-index: 2;
        }
      }

      // .moreBtn {
      //   width: 204px;
      //   height: 60px;
      //   border-radius: 30px;
      //   position: absolute;
      //   z-index: 2;
      //   right: 41px;
      //   transform: translateY(-50%);
      //   top: 50%;
      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      //   font-size: 18px;
      //   color: #FFFFFF;

      //   .more {
      //     font-size: 20px;
      //     font-weight: bold;
      //     margin-right: 5px;
      //   }
      // }
    }

    .goodsBox {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 34px;
      height: 409px;
      background: #FFFFFF;
      border-radius: 10px;
      padding: 20px 20px 25px;
      box-sizing: border-box;

      .right {
        width: 100%;
        overflow: hidden;

        .swiper {
          width: 100%;

          // height: 450px;
          .swiper-slide {
            // width: 1060px;
            // height: 450px;
          }
        }

        .cake {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-content: flex-start;
          box-sizing: border-box;
          position: relative;

          .module_img {
            width: 413px;
            height: 292px;
            display: inline-block;
            position: absolute;
            top: 10px;
            left: 10px;
            z-index: 4;
          }

          .module_img2 {
            width: 413px;
            height: 292px;
            display: inline-block;
            position: absolute;
            top: 10px;
            right: 10px;
            z-index: 4;
          }

          .item {
            width: 226px;
            box-sizing: border-box;
            background-color: #ffffff;
            border-radius: 12px;

            .img {
              width: 100%;
              height: 221px;
              border-radius: 12px;
              display: inline-block;
            }

            .info {
              width: 100%;
              background-color: #fff;
              padding: 16px 0;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              border-radius: 0 0 12px 12px;
              overflow: hidden;

              .name {
                width: 100%;
                font-size: 14px;
                color: #141414;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                word-break: break-all;
              }

              .free {
                height: 20px;
                line-height: 20px;
                font-size: 14px;
                color: #FE6428;
                margin: 6px 0 2px 0;
              }

              .infoBottom {
                display: flex;
                align-items: center;
                margin-top: 10px;

                .num {
                  font-size: 12px;
                  color: #999999;
                  margin-left: 8px;
                }

                .price {
                  font-size: 20px;
                  color: #FF1D18;
                  font-weight: bold;
                  font-family: PingFangSC, PingFang SC;

                  span {
                    font-size: 16px;
                    font-weight: 600;
                  }
                }
              }
            }
          }
        }
      }

      .more {
        width: 114px;
        height: 39px;
        background: #FFFFFF;
        border-radius: 6px;
        border: 1px solid #D7D7D7;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: #333333;
        margin-top: 25px;
        font-family: PingFangSC, PingFang SC;
      }
    }
  }
}
</style>